import useUnansweredLiveHelpRequestsCount from '@/components/Worlds/hooks/post/useUnansweredLiveHelpRequestsCount'
import NotificationBubble from '@/components/Worlds/UI/NotificationBubble'

export default function LiveHelpNotificationBubble({
  tutorWorldIds,
}: {
  tutorWorldIds: number[]
}): JSX.Element | null {
  const { count: activeRequestCount, loading } = useUnansweredLiveHelpRequestsCount({
    tutorWorldIds,
  })

  const isTutor = tutorWorldIds.length > 0

  if (!isTutor || loading || activeRequestCount < 1) {
    return null
  }

  return <NotificationBubble variant="large" value={activeRequestCount} />
}
